import moment from 'moment-timezone'

const DATE_ONLY_INPUT_FORMATS = [
  'MM/DD/YYYY',
  'MM-DD-YYYY',
  'YYYY-MM-DD',
  'YYYYMMDD',
  'MM.DD.YYYY',
  'M/DD/YYYY',
  'M-DD-YYYY',
  'YYYY-MM-DDTHH:mm:ss.SSSZ',
]

export const fromTimestamp = function (v, e) {
  if (!v) {
    return null
  }
  // Display in the viewer's own local timezone, with an explicit zone
  // abbreviation so it's always clear which timezone is being shown.
  var d = moment.tz(v, moment.tz.guess()).format('LLLL z')
  return d
}

export { formatPhoneDisplay } from './phone'

/**
 * Normalizes various date formats to MM/DD/YYYY
 * Handles formats like: YYYY-MM-DD, MM-DD-YYYY, MM/DD/YYYY, YYYYMMDD, etc.
 * @param {string} dateString - The date string to format
 * @returns {string} Date in MM/DD/YYYY format or 'N/A' if invalid
 */
export const formatDateToMMDDYYYY = function (dateString) {
  if (!dateString) {
    return 'N/A'
  }

  // Parse in UTC so the calendar date shown never shifts with the viewer's
  // local timezone — dateOfVasectomy/patientDob are logical calendar dates,
  // some stored as UTC-midnight ISO timestamps (see KitRequest.js comment).
  const date = moment.utc(dateString, DATE_ONLY_INPUT_FORMATS, true)

  if (date.isValid()) {
    return date.format('MM/DD/YYYY')
  }

  // If none of the formats work, return N/A
  return 'N/A'
}

/**
 * Parses logical calendar dates (DOB/DoV) in UTC and renders using the
 * browser's locale order while pinning to UTC to avoid day-shift regressions.
 * @param {string} dateString
 * @returns {string}
 */
export const formatDateToBrowserLocale = function (dateString) {
  if (!dateString) {
    return 'N/A'
  }

  const date = moment.utc(dateString, DATE_ONLY_INPUT_FORMATS, true)
  if (!date.isValid()) {
    return 'N/A'
  }

  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'UTC',
  }).format(date.toDate())
}
